import { Checkbox } from '@mui/material';
import React, { useContext } from 'react';
import { roundEuro } from '../../../functions/src/common/pricing';
import { langContext } from '../../api/Lang';
import { formatPriceEuro } from '../../api/priceFormat';

export function shouldShowPackageWalletCredits(balance: number, packagePrice: number): boolean {
    return roundEuro(balance) > 0 && roundEuro(packagePrice) > 0;
}

export default function PackageWalletCreditsRow({
    label,
    creditsUsed,
    balanceAfterRemain,
    remainLabel,
    compactAlign = false,
}: {
    label: string;
    creditsUsed: number;
    balanceAfterRemain: number;
    remainLabel: string;
    /** Step 3 payment summary — checkbox flush left, top-aligned with price */
    compactAlign?: boolean;
}) {
    const [lang] = useContext(langContext);

    return (
        <div className={`package-wallet-credits${compactAlign ? ' package-wallet-credits--step3' : ''}`}>
            <div className="offer-row package-wallet-credits-row">
                <div className="package-wallet-credits-left">
                    <Checkbox checked disabled color="primary" className="package-wallet-credits-checkbox" />
                    <span className="package-wallet-credits-label">{label}</span>
                    <span className="package-wallet-credits-remain">
                        {remainLabel}{' '}
                        <span>{formatPriceEuro(balanceAfterRemain, lang)}</span>
                    </span>
                </div>
                <span className="package-wallet-credits-amount">
                    {formatPriceEuro(creditsUsed, lang)}
                </span>
            </div>
        </div>
    );
}
